<template>
  <v-container fluid class="asset-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/asset/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="assets-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="headers"
              :items="assets"

              :items-per-page="assetPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Asset?
                    </v-card-title>
                    <v-card-text>
                      {{ deleteasset.assetcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteAsset(deleteasset)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.assetstatus="{ item }">
                <v-chip
                  :color="!item.assetstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.assetstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editAsset(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AssetList',
  data() {
    return {
      dialog: false,
      deleteasset: {},
      headers: [
        { text: 'Code', value: 'assetcode'},
        { text: 'Name', value: 'assetname'},
        { text: 'Type', value: 'assettype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Update', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      assetPerPage: 100,
      selected: [],      
    }
  },
  computed: {
    ...mapState('Asset', ['assets', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Asset' : 'Edit Asset'
    },
  },
  created () {
    this.getAssetsRequest()
  },

  methods: {
    ...mapActions('Asset', [
      "createAssetRequest",
      "deleteAssetRequest",
      "getAssetsRequest",
      "updateAssetRequest",
    ]),
    editAsset(item) {
      this.$router.push({ name: 'AssetEdit', params: item })
    },
    deleteAsset(item) {
      this.deleteAssetRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteasset = {
        _id: item._id,
        assetcode: item.assetcode,
      }
    },

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
